<script setup lang="ts">
import type { TabsPaneContext } from "element-plus";

import { defineEmits } from "vue";
import { defineProps } from "vue";

import { ElTabs } from "element-plus";
import { ElTabPane } from "element-plus";

const props = defineProps<{
  onChange: (tabId: string) => void;
  selectedTab: string;
  tabs: {
    id: string;
    label: string;
    component: any;
  }[];
}>();

const emit = defineEmits(["change"]);
const onSelect = (tab: TabsPaneContext) => {
  emit("change", tab.paneName);
};
</script>

<template>
  <div class="vi-tabs">
    <ElTabs
      class="vi-tab"
      :model-value="props.selectedTab"
      @tab-click="onSelect"
    >
      <ElTabPane
        v-for="tab of props.tabs"
        :key="tab.id"
        :label="tab.label"
        :name="tab.id"
      >
        <component :is="tab.component" />
      </ElTabPane>
    </ElTabs>
  </div>
</template>

<style scoped lang="scss">
.vi-tabs {
  :deep(.el-tabs__item) {
    padding: 13px 0 14px;
    margin: 0 25px;
    border-bottom: 2px solid transparent;
  }

  :deep(.el-tabs__item.is-active) {
    color: #2972ca;
    border-bottom: 2px solid #2972ca;
  }
}
</style>
